import axios from "axios";
// import store from '@/store'
import { Dialog, Toast } from "vant";
import router from "@/router";
import { weChatAuth } from "@/util/wxAuth.js";

// const isDev = process.env.NODE_ENV
const service = axios.create({
  baseURL: "",
  timeout: 5000,
});

service.interceptors.request.use(
  (config) => {
    let token = window.localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = "Bearer " + token;
    }
    Toast.loading({
      message: "加载中...",
      forbidClick: true,
      duration: 0,
    });
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    // const status = Number(response.status) || 200;
    // if (status === 424) {
    //   Dialog.alert({
    //     title: "提示",
    //     message: "身份认证已过期，请重新登陆",
    //   }).then(() => {
    //     window.localStorage.removeItem("token");
    //     router.push("/login");
    //   });
    // }
    Toast.clear();
    return response;
  },
  (error) => {
    Toast.clear();
    if (error.response.status == 401) {
      Toast.clear();
      router.replace("/login");
    } else if (error.response.status == 424) {
      Toast.clear();
      Dialog.alert({
        title: "提示",
        message: "身份认证已过期，请重新登陆",
        closeOnPopstate: true,
      }).then(() => {
        window.localStorage.removeItem("token");
        router.push("/login");
        // window.localStorage.removeItem("token");
        // window.sessionStorage.setItem("curPageUrl", window.location.href);
        // weChatAuth();
      });
    } else if (error.response.status == 428) {
      Toast.clear();
      Toast("验证码不正确");
    } else if (error.response.status == 401) {
      Toast.clear();
      Toast("用户不存在");
    }
  }
);
export default service;
